import type { HTMLAttributes } from 'react';

import IconX from '~icons/bx/x';

export function ButtonClose(props: HTMLAttributes<HTMLDivElement>) {
	return (
		<div css={{ color: 'inherit' }} {...props}>
			<IconX css={{ width: '1em', height: '1em' }} />
		</div>
	);
}
